import { getNotify } from '../../api';
import { useLocalStorage } from '../../utils/useLocalStorage';

const POPUP_COOLDOWN_MS = 30 * 60 * 1000;
const POPUP_CLOSED_KEY = 'notification_popup_closed_at';

function canShowPopup() {
  const storage = useLocalStorage(POPUP_CLOSED_KEY, null);
  const closedAt = storage.get();

  if (!closedAt) {
    return true;
  }

  const now = Date.now();
  const timeSinceClose = now - closedAt;

  return timeSinceClose >= POPUP_COOLDOWN_MS;
}

export default {
  namespaced: true,

  state: {
    headerNotify: {
      isShow: false,
      popupShow: false,
      title: '',
      body: '',
      type: '',
      url: '',
      image: '',
      width: 800,
    },
  },

  getters: {
    isNotifyVisible: (state) => state.headerNotify.isShow,
    isPopupVisible: (state) => state.headerNotify.popupShow,
  },

  mutations: {
    SET_HEADER_NOTIFY(state, notify) {
      state.headerNotify = {
        ...state.headerNotify,
        ...notify,
      };
    },

    SET_POPUP_VISIBLE(state, visible) {
      state.headerNotify.popupShow = visible;
    },
  },

  actions: {
    async fetchNotify({ commit }) {
      const notify = await getNotify();
      const shouldShowPopup = canShowPopup();

      commit('SET_HEADER_NOTIFY', {
        ...notify,
        popupShow: notify.popupShow && shouldShowPopup,
      });

      return notify;
    },

    openNotify({ commit }) {
      commit('SET_POPUP_VISIBLE', true);
    },

    closeNotify({ commit }) {
      commit('SET_POPUP_VISIBLE', false);

      const storage = useLocalStorage(POPUP_CLOSED_KEY, null);
      storage.set(Date.now());
    },
  },
};
